import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import _noop from 'lodash/noop';

import { pageTemplate } from '../../../styles/theme';
import { FavoriteTeamCardV1 } from '../../FavoriteTeamCard';
import PlayerCard from '../../PlayerCard';
import Carousel, { CAROUSEL_ITEM_PADDING } from '../../Carousel';

import { CardType } from './constants';

const PARTIAL_VISIBILITY_GUTTER = {
    xs: 0,
    sm: 0,
    md: 0,
    lg: 0,
    xl: 0,
};
const LAYOUT_ITEMS = {
    xs: 3,
    sm: 3,
    md: 3,
    lg: 3,
    xl: 3,
};

export const Team = styled(FavoriteTeamCardV1)`
    margin: ${({theme}) => `0 ${parseFloat(theme.pageTemplate.paddingLeftRight.xs)}px ${CAROUSEL_ITEM_PADDING.xs * 2}px`};
`;

const cardWidths = [
    {
        width: `100vw - ${(parseFloat(pageTemplate.paddingLeftRight.xs) * 2)}px`,
    },
];

const MobileView = (props) => {

    const {
        players,
        teamId,
        teamName,
        teamLink,
        teamLogoImageTemplateUrl,
        backgroundImageTemplateUrl,
        overlayStyles,
        playerImageTemplateUrl,
        loading,
        onItemClick,
        onAfterChange,
    } = props;

    const renderPlayerCard = useCallback((item, isLoading, index = 0) => (
        <PlayerCard
            as={Link}
            loading={isLoading}
            {...item}
            onClick={() =>
                onItemClick({
                    id: item.id ? item.name : CardType.EDIT,
                    index,
                    type: item.id ? CardType.PLAYER : CardType.EDIT,
                })
            }
        />
    ), [onItemClick]);

    const handleClick = useCallback(() => onItemClick({
        id: teamName,
        type: CardType.TEAM,
    }), [onItemClick, teamName]);

    return (
        <>
            <Team
                forwardedAs={Link}
                id={teamId}
                name={teamName}
                to={teamLink}
                teamLogoImageTemplateUrl={teamLogoImageTemplateUrl}
                backgroundImageTemplateUrl={backgroundImageTemplateUrl}
                overlayStyles={overlayStyles}
                playerImageTemplateUrl={playerImageTemplateUrl}
                loading={loading}
                cardWidths={cardWidths}
                onClick={handleClick}
            />
            <Carousel
                isLoading={loading}
                list={players}
                renderItem={renderPlayerCard}
                partialVisibilityGutter={PARTIAL_VISIBILITY_GUTTER}
                layoutItems={LAYOUT_ITEMS}
                onAfterChange={onAfterChange}
            />
        </>
    );

};

MobileView.propTypes = {
    teamId: PropTypes.number,
    teamName: PropTypes.string,
    teamLink: PropTypes.string,
    teamLogoImageTemplateUrl: PropTypes.string,
    backgroundImageTemplateUrl: PropTypes.string,
    overlayStyles: PropTypes.string,
    playerImageTemplateUrl: PropTypes.string,
    players: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            lastName: PropTypes.string,
            name: PropTypes.string,
            to: PropTypes.string,
        }).isRequired,
    ),
    loading: PropTypes.bool,
    onItemClick: PropTypes.func,
};

MobileView.defaultProps = {
    loading: false,
    onItemClick: _noop,
};

export default memo(MobileView);
